module.exports = __webpack_public_path__ + "img/close.decd6a24.svg";